const data = {
  id: "",
  step: 0,
  shirt: {},
  designnimg: "",
  designnimgback: "",
  color: "",
  realprice: 0,
  price: 0,
  day: 0,
  sales: 0,
  shirtname: "",
  brief: "",
  detail: "",
  campaign: 0,
  shirtdesign: [],
  shirtdesignback: [],
  frontDesignObj: null,
  backDesignObj: null,
  alterImage: null,
  edit: false,
  hello: {},
  seldata: false,
  shirtsdata1: "",
  shirtsdata2: "",
  sellingPrice: 0,
};

const Product = (state = data, action) => {
  switch (action.type) {
    case "PRODUCT":
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default Product;
